import { shouldSeeWorkEmailSuggestionAbTest } from "/services/ab-tests/acquisition-ab-test-service";
import { addParamToURL } from "/utils/url";
import softSignupTests from "/constants/signup-ab-tests";

const { getAbTestVariantNew } = require("/services/new-ab-tests/new-ab-tests-service");

const WORK_EMAIL_SUGGESTION_PARAM = "with_work_email_suggestion_test";
const AB_TEST_PARAM = "ssab";
const SIGNUP_SOURCE_PARAM = "source";

const WEBSITE_MAIN_SOURCE_VALUE = "web_main";

//	can test locally with overriding abTests with:
//	[{name:softSignupTests[0].test_name, variant: softSignupTests[0].new_variation_name}]

export const fireButtonClickAbTestEvent = (abTests) => {
  shouldSeeWorkEmailSuggestionAbTest(abTests, true);

  //	finding the test where the visitor is in and firing to BB that we are in it (regardless if new/old variant)
  const activeTest = getCurrentTest(abTests);
  if (!activeTest) return;
  getAbTestVariantNew(abTests, activeTest.test_name, true);
};

const getCurrentTest = (abTests) => {
  return softSignupTests.find((test) => {
    return test.platform_key && getAbTestVariantNew(abTests, test.test_name, false);
  });
};

const getActiveSoftSignupAbTestIfHavingNewVariant = (abTests) => {
  //	if visitor is in the test and the new variant is active, we return the test so we can append it to the URL
  const activeTest = getCurrentTest(abTests);
  if (!activeTest) return null;
  const isNewVariantActive =
    getAbTestVariantNew(abTests, activeTest.test_name, false) === activeTest.new_variation_name;
  return isNewVariantActive && activeTest;
};

export const addParamsToUrl = (url, abTests) => {
  url = addParamToURL(url, SIGNUP_SOURCE_PARAM, WEBSITE_MAIN_SOURCE_VALUE);

  if (shouldSeeWorkEmailSuggestionAbTest(abTests)) {
    url = addParamToURL(url, WORK_EMAIL_SUGGESTION_PARAM, "true");
  }

  const softSignupAbTest = getActiveSoftSignupAbTestIfHavingNewVariant(abTests);
  if (softSignupAbTest) {
    url = addParamToURL(url, AB_TEST_PARAM, softSignupAbTest.platform_key);
  }

  return url;
};
